import { useSignal } from "@preact/signals-react";
import Board from "componentsv2/board/Board";
import { layout as layoutFolio } from "../models/folio";

function Folios({ globalSearch }) {
  const layout = layoutFolio();
  const currentView = useSignal("list");
  return <Board layout={layout} currentView={currentView} />;
}

export default Folios;
